import React, { Component } from "react";
//import Navbar from "./../components/Navbars/Navbar";
import AppNavbarCable from "./../components/Navbars/Navbar-cable";
import { Button } from 'reactstrap';
//import { BASE_URL,AUTH_KEY } from './../config';
import axios from 'axios';
import NotificationAlert from 'react-notification-alert';
import { API_CONFIG } from "../config/config";

  const styles = ({
    backgroundColor: "#fff",
    fontSize: "15px",
    borderRadius: "8px",
    marginRight: "10px",
    marginLeft: "10px",
    padding: "10px 5px",
    textAlign: "center",
    margin:"5px"
  });

class ChargingCode extends Component {
  state={
    passCode:localStorage.getItem('passcode')
  }

  componentDidMount() {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    if (sessionId) {
      try {
        console.log("Session ID:", sessionId);
        this.fetchPassCode(sessionId);
      } catch (error) {
        console.error("Error retrieving session:", error);
      }
    } else {
      console.log("No session ID found in URL");
    }
  }

  fetchPassCode = (sessionId) => {
    const deviceId = localStorage.getItem('deviceId');
    const durationInHour =  sessionStorage.getItem('durationInHour');
    axios.get(`${API_CONFIG.HOST}/cable/${deviceId}/active-session`, {
      headers: {
        "Authorization": `${API_CONFIG.AUTH_KEY}`
      }
    })
    .then((response) => {
      if (response.data.sessionActive) {
       localStorage.setItem('passcode', response.data.passCode);
        this.setState({ passCode: response.data.passCode });
      } else {
        axios.get(`${API_CONFIG.HOST}/cable/${localStorage.getItem("deviceId")}/${durationInHour}/${sessionId}`, {
          headers: {
            "Authorization": `${API_CONFIG.AUTH_KEY}`
          }
        })
          .then((response) => {
                  localStorage.setItem('passcode', response.data.passCode);
                  this.setState({ passCode: response.data.passCode });
          });
      }
    }).catch(error => {
      console.log(error.response);
      this.setState({ loading: false });
      const options = {
        place: 'tr',
        message: `${error.response ? error.response.data : 'Something went wrong'}`,
        type: 'danger',
        icon: 'fas fa-exclamation-triangle',
        autoDismiss: 4
      };
      if (this.notification && this.notification.state.notifyTR.length < 1) {
        this.notification.notificationAlert(options);
      }
    });
  }

  handleSubmit = (e) => {
    this.fetchPassCode(); // Fetch a new passcode when the button is clicked
  }


    render() {
      console.log('props ',this.props);
        return(
            <>
            <AppNavbarCable {...this.props} />

            <NotificationAlert ref={(c) => { this.notification = c }} />
            <div style={styles} >
                <h5>Passcode</h5>
                <h2 style={{ marginBottom: 0 , color:"#64b352" }} id="passcode"> {this.state.passCode }</h2>
            </div>
            <div style={{ textAlign: "center" }}>
            <div style={{ padding: "2px 4px" }}>
                <img src="./Panel_Keys.png" alt="Logo" style={{ width: "25%", border: "1px solid #00D06A", borderRadius: "50%", padding: "4px" }} />
              </div>
              <div style={styles}>
                <h5>Enter Passcode on cable keypad.</h5>
              </div>
              <div style={{ padding: "2px 4px" }}>
                <img src="./Panel-GreenLight.png" alt="Logo" style={{ width: "25%", border: "1px solid #00D06A", borderRadius: "50%", padding: "4px" }} />
              </div>
              <div style={styles}>
                <h5>Once it's  green you can charge.</h5>
              </div>
              <div style={styles}>
                <h5>Click on  " Get New Code"  if  passcode did't work.</h5>
              </div>

              <Button
                id="rzp-button1"
                onClick={this.handleSubmit}
                block
                color="success"
                size="lg"
                style={{
                  position: "fixed",
                  border: 0,
                  borderRadius: 0,
                  bottom: 0
                }}
              >  Get New Code
             </Button>
             <div style={styles}>
                <h5>Invoice will be sent to given email Id.</h5>
              </div>
              </div>
            </>
        )
    }
}

export default ChargingCode;